import React, { useState } from 'react';
import { useAuthStore } from '../store';
import { detectAndConvert } from '../utils/layoutSwitch';
import '../styles/header.css';

const Header = ({
  onLogout, onAdmin, adminBadgeCount = 0, onSettings, onFilterToggle, activeFilterCount,
  search, onSearchChange, onSearch,
  sizes = [], selectedSizes = [], allSizes, withSizes,
  onSizeToggle, onAllSizesToggle, onWithSizesToggle, onSizesClear,
  alertsCount = 0, onAlerts,
  onSelection,
  currentFilters,
  onSwitchSection,
  canSwitchSection,
}) => {
  const user = useAuthStore((state) => state.user);
  const username = user?.username;
  const isAdmin = user?.is_admin;
  const isTeam = user?.is_team && !user?.is_admin;
  const hasRetail = !isAdmin && !isTeam && (user?.permissions || []).some(
    p => ['retail_sites', 'retail_publish', 'retail_site_admin'].includes(p)
  );
  const initials = (username || 'П').charAt(0).toUpperCase();

  const [suppressSuggestion, setSuppressSuggestion] = useState(false);
  const layoutSuggestion = suppressSuggestion ? null : detectAndConvert(search);

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img src="/logo.ico" alt="ALLDROP" className="logo-icon" />
          <h1>ALLDROP</h1>
        </div>

        <div className="header-search">
          <input
            type="text"
            className="header-search-input"
            placeholder="Поиск по названию, бренду..."
            value={search}
            onChange={(e) => { setSuppressSuggestion(false); onSearchChange(e.target.value); }}
            onFocus={() => setSuppressSuggestion(false)}
            onKeyDown={(e) => { if (e.key === 'Enter') { setSuppressSuggestion(true); onSearch(); } }}
          />
          {search && (
            <button className="search-clear" onClick={() => onSearchChange('')} title="Очистить">×</button>
          )}
          {layoutSuggestion && (
            <div className="layout-suggestion">
              <span
                className="layout-suggestion-text"
                onClick={() => { setSuppressSuggestion(true); onSearchChange(layoutSuggestion); onSearch(); }}
                title="Применить"
              >
                ⌨ {layoutSuggestion}
              </span>
              <span className="layout-suggestion-close" onClick={() => setSuppressSuggestion(true)} title="Закрыть">×</span>
            </div>
          )}
        </div>

        <div className="header-right">
          {canSwitchSection && onSwitchSection && (
            <button className="section-switch-btn" onClick={() => onSwitchSection('clothing')} title="Одежда">
              <span className="section-switch-label">Одежда</span>
              <span className="section-switch-icon">👕</span>
            </button>
          )}
          {isAdmin && (
            <button className="admin-panel-btn" onClick={onAdmin} title="Панель администратора">
              Управление
              {adminBadgeCount > 0 && (
                <span className="admin-panel-badge">{adminBadgeCount}</span>
              )}
            </button>
          )}
          {isTeam && (
            <button className="admin-panel-btn admin-panel-btn--team" onClick={onAdmin} title="Аналитика">
              Аналитика
            </button>
          )}
          {hasRetail && (
            <button className="admin-panel-btn admin-panel-btn--team" onClick={onAdmin} title="Розница">
              Розница
            </button>
          )}
          {onFilterToggle && (
            <button className="filter-toggle-btn mobile-only" onClick={onFilterToggle} title="Фильтры">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="9" y1="18" x2="15" y2="18"/>
              </svg>
              {activeFilterCount > 0 && <span className="filter-badge">{activeFilterCount}</span>}
            </button>
          )}
          <button className="header-selection-btn" onClick={onSelection} title="Подборка товаров">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
          </button>
          {onAlerts && (
            <button
              className={`header-bell-btn${alertsCount > 0 ? ' has-alerts' : ''}`}
              onClick={onAlerts}
              title="Мои подписки"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
              </svg>
              {alertsCount > 0 && <span className="header-bell-count">{alertsCount}</span>}
            </button>
          )}
          <button className="settings-btn" onClick={onSettings} title="Настройки">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
          </button>
          <button className="user-badge" onClick={onLogout} title="Выход">
            <span className="user-avatar">{initials}</span>
          </button>
        </div>
      </div>

      {sizes.length > 0 && (
        <div className="size-bar">
          {sizes.map((size) => (
            <button
              key={size}
              className={`size-chip ${selectedSizes.includes(size) ? 'active' : ''}`}
              onClick={() => onSizeToggle(size)}
            >
              {size}
            </button>
          ))}
          <div className="size-bar-divider" />
          <label className={`size-option ${allSizes ? 'active' : ''}`}>
            <input type="checkbox" checked={allSizes} onChange={onAllSizesToggle} disabled={selectedSizes.length < 2} />
            Парные
          </label>
          <label className={`size-option ${withSizes ? 'active' : ''}`}>
            <input type="checkbox" checked={withSizes} onChange={onWithSizesToggle} />
            Скрыть без размеров
          </label>
          {(selectedSizes.length > 0 || allSizes || withSizes) && (
            <button className="btn-clear" onClick={onSizesClear}>Сбросить</button>
          )}
          <button className="btn-selection-bar" onClick={() => onSelection(currentFilters)} title="Открыть подборку с текущими фильтрами">
            Подборка
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
